// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"af65d425","59":"f3473483","97":"a7f8b844","113":"48502e6b","129":"48f1ff79","282":"edcaac26","366":"4f22f665","399":"9fa5276c","481":"75a1caa6","488":"371f7511","742":"db7cd4f5","790":"ee5f9e9c"}[chunkId] + ".chunk.js";
};